import { setLocale } from 'yup';
import { en, nl } from 'yup-locales';

// Individual exports for testing
function setYupLocale(locale) {
  setLocale(locale === 'nl' ? nl : en);
}

export default setYupLocale;
